// export let BASE_URL = "http://localhost:8080/api";
// export let BASE_URL = "https://quality-web-developer.com:4500/api";
// export let BASE_IMAGE_URL="http://localhost:4500/"
// export let BASE_IMAGE_URL="https://quality-web-developer.com:4500/"
export let BASE_URL="https://api.shapebysarah.com/api"
// export let BASE_URL="https://staging.shapebysarah.com:8080/api"
export let BASE_IMAGE_URL_NODE="https://api.shapebysarah.com/"
export let BASE_IMAGE_URL = "https://assets.shapebysarah.com/";
export let BASE_AWS_URL="https://assets.shapebysarah.com/"
// export let BASE_AWS_URL="https://shapebysarah-assets.s3.eu-central-1.amazonaws.com/"